import axios from '@/jslib/axios'

export const getHanbergList = (params,other) => {
  return axios({
    method: 'get',
    url: '/admin/hanberg/list',
    params,
    ...other
  })
}
export const getHanbergDetail= params => {
  return axios({
    method: 'get',
    url: '/admin/hanberg/detail',
    params
  })
}
export const updateHanbergStatus = data => {
  return axios({
    method: 'post',
    url: '/admin/hanberg/update/status',
    data
  })
}
export const addHanbergRemark = data => {
  return axios({
    method: 'post',
    url: '/admin/hanberg/remark/add',
    data
  })
}
